export class ImageConstants {
  static main_logo =
    "https://res.cloudinary.com/cqn/image/upload/v1708703521/AceTech_2_fmqpw4.png";
  static courses_page_logo =
    "https://res.cloudinary.com/cqn/image/upload/v1710679794/AceTechLogo_jmww7n.png";
  static realworld_icon =
    "https://res.cloudinary.com/cqn/image/upload/v1708703547/programming_feaiej.png";

  static certificate_icon =
    "https://res.cloudinary.com/cqn/image/upload/v1708703552/certificate_pkv390.png";
  static flexible_time_icon =
    "https://res.cloudinary.com/cqn/image/upload/v1708703579/timetable_ab8nx9.png";

  static my_semi_circle =
    "https://res.cloudinary.com/cqn/image/upload/v1708703507/circle_fg0hfw.png";

  static video_about_company =
    "https://cdn.discordapp.com/attachments/1107210971124080643/1204478637294747759/about_company_video.mp4?ex=65d4e125&is=65c26c25&hm=d5469c5b2531a73a7c993af575e2280dcc25853826cd13ea82ccbc2551a051c9&";

  static about_company_girl_image =
    "https://cdn.discordapp.com/attachments/1107210971124080643/1206182667465261107/animated_background_video.mp4?ex=65db1425&is=65c89f25&hm=62e83838982765ef60d8cc9ad33533876c6eea2cdb0a98fdf432fced33f2e3cd&";

  static commas_image =
    "https://res.cloudinary.com/cqn/image/upload/v1708703584/commas_t4nbnl.png";

  static instagram_project_image =
    "https://res.cloudinary.com/cqn/image/upload/v1708703604/instagram_project_rfpgk7.png";
  static video_project_image =
    "https://res.cloudinary.com/cqn/image/upload/v1708703615/video_project_image_mjgkll.png";
  static shopping_project_image =
    "https://res.cloudinary.com/cqn/image/upload/v1708703619/shopping_project_image_c4z7ar.png";
  static distribute_project_image =
    "https://res.cloudinary.com/cqn/image/upload/v1708703643/distribution_project_image_keplmu.png";
  static profile_image_1 =
    "https://res.cloudinary.com/cqn/image/upload/v1716064808/aditya_shakya_frsjs0.png";
  static profile_image_2 =
    "https://res.cloudinary.com/cqn/image/upload/v1716064764/tejas_shelar_gjvtl1.png";
  static profile_image_3 =
    "https://res.cloudinary.com/cqn/image/upload/v1716064656/snehal_more_ldefb4.png";
  static logo_image =
    "https://cdn.discordapp.com/attachments/1107210971124080643/1201925254868369469/AceTech_2.png?ex=65cb971f&is=65b9221f&hm=7eb1e7d0d10dc9c717979aa5064d012d34e2edbce53f3643976970a92b4dc60c&";
  static login_page_image1 =
    "https://res.cloudinary.com/cqn/image/upload/v1716725568/login_image_1_e62kvq.png";
  static login_page_image2 =
    "https://res.cloudinary.com/cqn/image/upload/v1716739519/login_image_2_ndljjv.png";
  static login_page_image3 =
    "https://res.cloudinary.com/cqn/image/upload/v1716739790/login_image_3_xrvbnr.png";
  static signUp_page_image =
    "https://res.cloudinary.com/cqn/image/upload/v1708977112/signup_page_image_vydtgs.png";
  static courses_certificate_image =
    "https://res.cloudinary.com/cqn/image/upload/v1709662683/certificate_courses_page_okepdp.png";
  static getUserProfile_image =
    "https://images.unsplash.com/photo-1524860769472-246b6afea403?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";
  static getCertificatesListImage =
    "https://res.cloudinary.com/cqn/image/upload/v1710706125/acetech_certificates_list_qhhsup.png";

  static getBadgeImage =
    "https://res.cloudinary.com/cqn/image/upload/v1710783594/gold-seal-badge-11546974016ucwnwtduvc-removebg-preview_dntnxq.png";
  static getIncreasingRevenue =
    "https://res.cloudinary.com/cqn/image/upload/v1710784483/increasing_revenue_cua0nf.png";
  static getRecruiterImage =
    "https://res.cloudinary.com/cqn/image/upload/v1710784674/recruiter_buvs4f.png";
  static getLinesImage =
    "https://res.cloudinary.com/cqn/image/upload/v1710785800/lines_o4p0kv.png";
  static getBasicCertificateImage =
    "https://res.cloudinary.com/cqn/image/upload/v1711196127/fullstack_certificate_jr4kq3.png";
  static getIntermediateCertificateImage =
    "https://res.cloudinary.com/cqn/image/upload/v1711196127/fullstack_certificate_jr4kq3.png";
  static getAdvancedCertificateImage =
    "https://res.cloudinary.com/cqn/image/upload/v1711196127/fullstack_certificate_jr4kq3.png";
  static getAvatarImage =
    "https://images.unsplash.com/photo-1524860769472-246b6afea403?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

  static getTempImage =
    "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

  static getDashboardLogo =
    "https://res.cloudinary.com/cqn/image/upload/v1712085811/white_acetechies_logo_wtuabw.png";

  static getDashboardTopLogo =
    "https://res.cloudinary.com/cqn/image/upload/v1712160770/dashboard_top_image_zqi0or.png";
  static getDashboardCertifcateTopImage =
    "https://res.cloudinary.com/cqn/image/upload/v1712420695/dashboard_certificate_top_image_e8szvz.png";
  static getDashboardCoursesTopImage =
    "https://res.cloudinary.com/cqn/image/upload/v1712430182/dashboard_courses_image_rtstgo.png";
  static getStaticProblemStatementImage =
    "https://cdn.dribbble.com/userupload/8587680/file/original-2746ea57df22f4e217d4eabb3ad2bd2a.jpeg?resize=1200x900";
  static getNotFoundImage =
    "https://res.cloudinary.com/cqn/image/upload/v1712848631/nothing_found_bgmrvo.png";
  static getSupportImage =
    "https://res.cloudinary.com/cqn/image/upload/v1712946858/support_background_image_d95pan.png";
  static getLiveIcon =
    "https://res.cloudinary.com/cqn/image/upload/v1714247844/live_cspbb8.png";
}

export class StringConstants {
  static realworld_subtitleString =
    "Create real-world applications, boost your resume and land jobs in companies offering more than 8+LPA";
  static certification_string =
    "Acquire our frontend, backend, and fullstack certificates to excel in interviews and land high-paying jobs.";
  static flexible_string =
    "Students can view videos according to their flexibility and learn and create applications";
  static our_program_card1 =
    "Create Projects that will standout your resume and get the call from companies. We help students create projects which includes Playing ads in between videos?, Creating a instagram like algorithm and show similar image feed and reels?, Create in video shopping commerce and much more...";
  static our_program_card2 =
    "Elevate your resume with our frontend, backend, and fullstack certifications. Validate your expertise and stand out in the tech industry. Gain specialized skills that open doors to exciting career opportunities. Take your professional profile to the next level with us.";

  static our_program_card3 =
    "Access curated video playlists and master end-to-end frontend, backend, and fullstack projects with ease. Our comprehensive tutorials empower students to develop robust skills across the tech spectrum, ensuring readiness for real-world challenges and career success.";

  static tejas_comment =
    "Grateful for Acetech's exceptional course videos, enabling me to craft standout projects, enhancing my resume. Their guidance has been invaluable for my professional journey.";
  static aditya_comment =
    "I'm grateful for Acetech's exceptional course videos, which have enhanced my projects and resume. Their invaluable guidance has propelled my professional journey.";
  static snehal_comment =
    "Thanks to Acetech's exceptional course videos, I've crafted standout projects and boosted my resume. Their guidance has been invaluable for my professional journey, and I'm truly grateful for their support.";

  static certifyNow = "Certify now, boost interview chances by 78%!";
  static revenueBoost = "Certify now, Get 8+ LPA job offers!";
  static recruiterSearch = "Certify now, Get Interview calls from big MNCs.";
  static stepperStep1String =
    "Select the problem from the list of problem statement. Requirements are listed for each problem statement along with videos or images of expected results.";
  static stepperStep2String =
    "Once completed, add your solution to github(we have shared how to add your solution to github) and share the link with us.";
  static stepperStep3String =
    "We will review and share your certificate on your email.";
}

export class ExternalLinks {
  static linkedIn = "https://www.linkedin.com/in/acetechies-academy-165b282b3/";
}

export class MoneySigns {
  static indianRupees = "₹";
}

export const collegeData = [
  {
    id: 1,
    src: "https://medha.org.in/user-content/media-versions/1400w_x2400h__q_90_c_Navgurukul.jpg",
    name: "Navgurukul",
  },
  {
    id: 2,
    src: "https://d2lk14jtvqry1q.cloudfront.net/media/large_177_35e5fdfc68_7f73ce2c67.png",
    name: "Indira Gandhi Technical University for Women",
  },
  {
    id: 3,
    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzPKlZeJZBWaQFzyzbQxPxzE_5WqVx5jZJ6Q&s",
    name: "Nutan College of Engineering and Research ",
  },
  {
    id: 1,
    src: "https://almashines.s3.dualstack.ap-southeast-1.amazonaws.com/assets/images/institutes/logo/170x170/949.jpg?v=1655352495",
    name: "Madhav Institute of Technology and Science ",
  },
];

export const workshopReviews = [
  {
    id: 1,
    review:
      "Acetech's Live Workshop was awesome! Helped me build cool projects and boost my resume. Really thankful for their guidance.",
    fullName: "Shivam Shrivastava",
    profileImage: ImageConstants.profile_image_1,
    stars: 5,
  },
  {
    id: 2,
    review:
      "Loved Acetech's workshop! Made some solid projects and improved my resume. Their tips were super helpful.",
    fullName: "Vishal Sachdev",
    profileImage: ImageConstants.profile_image_2,
    stars: 4,
  },
  {
    id: 3,
    review:
      "Acetech's workshop was a game-changer. Built great projects, and my resume looks better now. Grateful for their support!",
    fullName: "Vedashree Bhawsar",
    profileImage: ImageConstants.profile_image_3,
    stars: 4,
  },
  {
    id: 4,
    review:
      "Superb experience with Acetech's workshop! Learned a lot, made projects, and got good career advice.",
    fullName: "Priya Sharma",
    profileImage: ImageConstants.profile_image_4,
    stars: 5,
  },
  {
    id: 5,
    review:
      "Acetech's Live Workshop was too good! Helped me with projects and resume. Really worth it.",
    fullName: "Rohan Patil",
    profileImage: ImageConstants.profile_image_5,
    stars: 4,
  },
  {
    id: 6,
    review:
      "Had fun at Acetech's workshop! Built some nice projects and got useful guidance for my career.",
    fullName: "Neha Gupta",
    profileImage: ImageConstants.profile_image_6,
    stars: 5,
  },
  {
    id: 7,
    review:
      "Acetech's workshop was amazing yaar! Projects turned out well, and my resume looks stronger now.",
    fullName: "Aakash Verma",
    profileImage: ImageConstants.profile_image_7,
    stars: 4,
  },
  {
    id: 8,
    review:
      "Thanks to Acetech's workshop, I made decent projects and learned a lot. Helped me level up!",
    fullName: "Sneha Kulkarni",
    profileImage: ImageConstants.profile_image_8,
    stars: 5,
  },
];

export const companies = [
  {
    src: "https://res.cloudinary.com/cqn/image/upload/v1741804276/Amazon-Logo-2000-present-1024x576-removebg-preview_gvtwgl.png",
  },
  {
    src: "https://res.cloudinary.com/cqn/image/upload/v1741804276/images-removebg-preview_wehb6a.png",
  },
  {
    src: "https://res.cloudinary.com/cqn/image/upload/v1741804276/Capgemini-Logo-removebg-preview_hkjujv.png",
  },
  {
    src: "https://res.cloudinary.com/cqn/image/upload/v1741804276/images-removebg-preview_1_tmdqwk.png",
  },
  {
    src: "https://res.cloudinary.com/cqn/image/upload/v1741804275/Meesho-682x435-removebg-preview_e8tvkj.png",
  },
  {
    src: "https://res.cloudinary.com/cqn/image/upload/v1741804275/RWCZER-Legal-IP-Trademarks-CP-MS-logo-740x417-1-removebg-preview_e72dsp.png",
  },
];

export const faqs = [
  {
    question: "What is the duration of the Workshop/Bootcamp?",
    answer: "The Workshop/Bootcamp duration usually are of 3 to 5 Days.",
  },
  {
    question: "Is there any specific software I need to use?",
    answer: "There are no extra softwares that are needed to be installed.",
  },
  {
    question: "Will I receive a certificate upon completion?",
    answer: "Yes, all Programs provide a certificate upon completion.",
  },
  {
    question: "In what platform will the classes be hosted?",
    answer: "Classes will be hosted LIVE on Google Meet.",
  },
  {
    question: "Will there be any projects covered in the Workshop/Bootcamp?",
    answer: "Yes, each Workshop/Bootcamp has a project that will be covered.",
  },
];

export const profileImages = [
  "https://i.pinimg.com/736x/a9/2b/69/a92b69934e0a8391ac72df6fcac30254.jpg",
  "https://i.pinimg.com/736x/7d/1a/d3/7d1ad387d369b8586eb01ab5b247dfbf.jpg",
  "https://i.pinimg.com/736x/bd/a7/62/bda762d92fb045b0ba5d0d6e00668a78.jpg",
  "https://i.pinimg.com/736x/f2/fa/a4/f2faa44cc72d5d11d59f031962f3c7bc.jpg",
];

export const TAGS_BY_FIELD = {
  frontend: [
    "#Frontend",
    "#WebDevelopment",
    "#JavaScript",
    "#ReactJS",
    "#HTML",
    "#CSS",
    "#Learning",
  ],
  backend: [
    "#Backend",
    "#NodeJS",
    "#APIs",
    "#MongoDB",
    "#ExpressJS",
    "#WebDevelopment",
    "#Learning",
  ],
  fullstack: [
    "#Fullstack",
    "#MERN",
    "#WebDevelopment",
    "#JavaScript",
    "#ReactJS",
    "#NodeJS",
    "#Learning",
  ],
  mobile: [
    "#MobileDevelopment",
    "#Flutter",
    "#ReactNative",
    "#Android",
    "#iOS",
    "#Learning",
  ],
  ai: [
    "#AI",
    "#MachineLearning",
    "#DeepLearning",
    "#Python",
    "#TechLearning",
    "#Innovation",
  ],
};

export const generateTags = (fieldKey) => {
  if (!fieldKey || typeof fieldKey !== "string") return "";

  const tags = TAGS_BY_FIELD[fieldKey.toLowerCase().trim()] || [
    "#TechLearning",
    "#SkillBuilding",
  ];

  return tags.join(" ");
};

export const initialProfileData = {
  name: "John Doe",
  introTitle: "I help founders turn ideas into seamless digital experiences",
  title: "Full Stack Developer",
  email: "john.doe@example.com",
  profilePicture:
    "https://plus.unsplash.com/premium_photo-1690407617542-2f210cf20d7e?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  githubLink: "https://github.com/Shreyash2001",
  linkedinLink: "https://www.linkedin.com/in/shreyash-katare-90a419172/",
  resumeLink: "https://viewmyresume.com",
  selectedSkills: [
    {
      id: 1,
      name: "React",
      icon: "https://cdn.worldvectorlogo.com/logos/react-1.svg",
    },
    {
      id: 2,
      name: "Node.js",
      icon: "https://cdn.worldvectorlogo.com/logos/nodejs-2.svg",
    },
  ],
  experiences: [
    {
      experience_id: "1",
      logo: "https://images.unsplash.com/photo-1551263640-1c007852f616?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      company: "Innovate Corp",
      title: "Lead Frontend Developer",
      startDate: "2022",
      endDate: "Present",
      details:
        "Leading the development of a cutting-edge web platform, focusing on user experience and performance. Mentoring junior developers and driving architectural decisions.",
      techStack: [
        {
          id: 1,
          name: "React",
          icon: "https://cdn.worldvectorlogo.com/logos/react-1.svg",
        },
        {
          id: 2,
          name: "Node.js",
          icon: "https://cdn.worldvectorlogo.com/logos/nodejs-2.svg",
        },
      ],
    },
    {
      experience_id: "2",
      logo: "https://images.unsplash.com/photo-1551263640-1c007852f616?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      company: "Creative Solutions",
      title: "Software Engineer",
      startDate: "2020",
      endDate: "2022",
      details:
        "Developed and maintained client-facing applications using modern JavaScript frameworks. Collaborated with cross-functional teams to deliver high-quality software.",
      techStack: [
        {
          name: "Vue.js",
          icon: "https://cdn.worldvectorlogo.com/logos/vue-9.svg",
          id: 1,
        },
        {
          name: "Firebase",
          icon: "https://cdn.worldvectorlogo.com/logos/firebase-3.svg",
          id: 2,
        },
      ],
    },
  ],
  projects: [
    {
      id: 1,
      title: "E-commerce Platform",
      image:
        "https://cdn.dribbble.com/userupload/12647164/file/original-83e6a37ff577cf382222f4c0ff6ad876.png?resize=1600x1200&vertical=center",
      details:
        "A fully responsive e-commerce platform built with a modern tech stack, providing a seamless shopping experience from browsing to checkout.",
      githubLink: "https://github.com/Shreyash2001",
      techStack: [
        {
          id: 1,
          name: "React",
          icon: "https://cdn.worldvectorlogo.com/logos/react-1.svg",
        },
      ],
      highlights: [
        { id: 1, title: "Server-side rendering for improved SEO" },
        { id: 2, title: "Real-time inventory updates" },
        { id: 3, title: "Secure payment gateway integration" },
      ],
    },
  ],
  certificates: [
    {
      id: 1,
      title: "MERN Stack Certification",
      certificateIssuedByAcetechies: true,
      image:
        "https://res.cloudinary.com/cqn/image/upload/v1711196127/fullstack_certificate_jr4kq3.png",
      details:
        "A comprehensive course on advanced state management, performance optimization, and architectural patterns in React.",
      techStack: [
        {
          id: 1,
          name: "React",
          icon: "https://cdn.worldvectorlogo.com/logos/react-1.svg",
        },
      ],
      projectSolutions: [
        {
          id: 1,
          title: "E-commerce Platform Frontend",
          details:
            "A modern, responsive frontend for an e-commerce site built with React, featuring state management with Redux Toolkit and a dynamic shopping cart.",
          img: "https://res.cloudinary.com/cqn/image/upload/v1711196127/fullstack_certificate_jr4kq3.png",
          githubLink: "https://github.com/your-username/ecommerce-frontend",
        },
      ],
    },
    {
      id: 2,
      title: "Node.js Certification",
      certificateIssuedByAcetechies: false,
      image:
        "https://res.cloudinary.com/cqn/image/upload/v1711196127/fullstack_certificate_jr4kq3.png",
      details:
        "A comprehensive course on advanced state management, performance optimization, and architectural patterns in React.",
      techStack: [
        {
          id: 2,
          name: "Node.js",
          icon: "https://cdn.worldvectorlogo.com/logos/nodejs-2.svg",
        },
      ],
      projectSolutions: [
        {
          id: 1,
          title: "E-commerce Platform Frontend",
          details:
            "A modern, responsive frontend for an e-commerce site built with React, featuring state management with Redux Toolkit and a dynamic shopping cart.",
          img: "https://res.cloudinary.com/cqn/image/upload/v1711196127/fullstack_certificate_jr4kq3.png",
          githubLink: "https://github.com/your-username/ecommerce-frontend",
        },
      ],
    },
  ],
  technicalAchievements: {
    currentActiveTab: "github",
    platforms: [
      {
        id: "github",
        platformName: "GitHub",
        username: "your-username",
        profileLink: "https://github.com/your-username",
        stats: {
          totalRepos: 42,
          languages: [
            { name: "JavaScript", value: 65.5 },
            { name: "TypeScript", value: 25.2 },
            { name: "HTML", value: 5.1 },
            { name: "CSS", value: 4.2 },
          ],
          lastFetched: "2025-10-07T00:00:00.000Z",
        },
      },
      {
        id: "leetcode",
        platformName: "LeetCode",
        username: "your-leetcode-username",
        profileLink: "https://leetcode.com/your-leetcode-username/",
        stats: { easy: 150, medium: 200, hard: 50 },
        badges: [
          {
            id: "badge1",
            url: "https://leetcode.com/static/images/badges/2022/gif/2022-annual-100.gif",
            alt: "Annual 100",
          },
        ],
      },
      {
        id: "gfg",
        platformName: "GeeksforGeeks",
        username: "your-gfg-username",
        profileLink: "https://auth.geeksforgeeks.org/user/your-gfg-username",
        stats: { easy: 100, medium: 120, hard: 30 },
      },
    ],
  },
  contactDetails: {
    title: "From Concept to Creation Let's Make It Happen!",
    availabilityTitle:
      "I'm available for full-time roles & freelance projects.",
    availabilitySubtitle:
      "I thrive on crafting dynamic web applications, and delivering seamless user experiences.",
    footerLine: "@2025 your name. All rights reserved",
  },
};

export const allSkills = [
  {
    id: 1,
    name: "React",
    icon: "https://cdn.worldvectorlogo.com/logos/react-1.svg",
  },
  {
    id: 2,
    name: "Node.js",
    icon: "https://cdn.worldvectorlogo.com/logos/nodejs-2.svg",
  },
  {
    id: 3,
    name: "JavaScript",
    icon: "https://cdn.worldvectorlogo.com/logos/javascript-1.svg",
  },
  {
    id: 4,
    name: "HTML5",
    icon: "https://cdn.worldvectorlogo.com/logos/html-5-logo-svg-1.svg",
  },
  {
    id: 5,
    name: "CSS3",
    icon: "https://cdn.worldvectorlogo.com/logos/css-3.svg",
  },
  {
    id: 6,
    name: "MongoDB",
    icon: "https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg",
  },
  {
    id: 7,
    name: "Python",
    icon: "https://cdn.worldvectorlogo.com/logos/python-5.svg",
  },
  {
    id: 8,
    name: "Typescript",
    icon: "https://cdn.worldvectorlogo.com/logos/typescript.svg",
  },
  {
    id: 9,
    name: "Next.js",
    icon: "https://cdn.worldvectorlogo.com/logos/nextjs-13.svg",
  },
  {
    id: 10,
    name: "Angular",
    icon: "https://cdn.worldvectorlogo.com/logos/angular-3.svg",
  },
  {
    id: 11,
    name: "Vue.js",
    icon: "https://cdn.worldvectorlogo.com/logos/vue-9.svg",
  },
  {
    id: 12,
    name: "Redux",
    icon: "https://cdn.worldvectorlogo.com/logos/redux.svg",
  },
  {
    id: 13,
    name: "Zustand",
    icon: "https://repository-images.githubusercontent.com/180328715/fca49300-e7f1-11ea-9f51-cfd949b31560",
  },
  {
    id: 14,
    name: "Tailwind Css",
    icon: "https://cdn.worldvectorlogo.com/logos/tailwind-css-1.svg",
  },
  {
    id: 15,
    name: "Bootstrap",
    icon: "https://cdn.worldvectorlogo.com/logos/bootstrap-5.svg",
  },
  {
    id: 16,
    name: "Material UI",
    icon: "https://cdn.worldvectorlogo.com/logos/material-ui-1.svg",
  },
  {
    id: 17,
    name: "Framer Motion",
    icon: "https://cdn.worldvectorlogo.com/logos/framer-1.svg",
  },
  {
    id: 18,
    name: "Express.js",
    icon: "https://cdn.worldvectorlogo.com/logos/expressjs.svg",
  },
  {
    id: 19,
    name: "Java",
    icon: "https://cdn.worldvectorlogo.com/logos/java-4.svg",
  },
  {
    id: 20,
    name: "Java Spring Boot",
    icon: "https://cdn.worldvectorlogo.com/logos/spring-boot-1.svg",
  },
  {
    id: 21,
    name: "Django",
    icon: "https://cdn.worldvectorlogo.com/logos/django-community.svg",
  },
  {
    id: 22,
    name: "Flask",
    icon: "https://cdn.worldvectorlogo.com/logos/flask.svg",
  },
  {
    id: 23,
    name: "Fastapi",
    icon: "https://cdn.worldvectorlogo.com/logos/fastapi-1.svg",
  },
  {
    id: 24,
    name: "PHP",
    icon: "https://cdn.worldvectorlogo.com/logos/php-6.svg",
  },
  {
    id: 25,
    name: "Ruby on Rails",
    icon: "https://cdn.worldvectorlogo.com/logos/ruby.svg",
  },
  {
    id: 26,
    name: "MySQL",
    icon: "https://cdn.worldvectorlogo.com/logos/mysql-2.svg",
  },
  {
    id: 27,
    name: "PostgreSQL",
    icon: "https://cdn.worldvectorlogo.com/logos/postgresql.svg",
  },
  {
    id: 28,
    name: "SQLite",
    icon: "https://cdn.worldvectorlogo.com/logos/sqlite.svg",
  },
  {
    id: 29,
    name: "Oracle",
    icon: "https://cdn.worldvectorlogo.com/logos/oracle-6.svg",
  },
  {
    id: 30,
    name: "Redis",
    icon: "https://cdn.worldvectorlogo.com/logos/redis.svg",
  },
  {
    id: 31,
    name: "Firebase",
    icon: "https://cdn.worldvectorlogo.com/logos/firebase-3.svg",
  },
  {
    id: 32,
    name: "Dynamo DB",
    icon: "https://cdn.worldvectorlogo.com/logos/aws-dynamodb.svg",
  },
  {
    id: 33,
    name: "AWS",
    icon: "https://cdn.worldvectorlogo.com/logos/amazon-web-services-2.svg",
  },
  {
    id: 34,
    name: "Microsoft Azure",
    icon: "https://cdn.worldvectorlogo.com/logos/microsoft-azure-2.svg",
  },
  {
    id: 35,
    name: "Google Cloud Platform",
    icon: "https://cdn.worldvectorlogo.com/logos/google-cloud-3.svg",
  },
  {
    id: 36,
    name: "Cloudfare",
    icon: "https://cdn.worldvectorlogo.com/logos/cloudflare-1.svg",
  },
  {
    id: 37,
    name: "Docker",
    icon: "https://cdn.worldvectorlogo.com/logos/docker.svg",
  },
  {
    id: 38,
    name: "Kubernetes",
    icon: "https://cdn.worldvectorlogo.com/logos/kubernets.svg",
  },
  {
    id: 39,
    name: "Github",
    icon: "https://cdn.worldvectorlogo.com/logos/github-icon-2.svg",
  },
  {
    id: 40,
    name: "Gitlab",
    icon: "https://cdn.worldvectorlogo.com/logos/gitlab-1.svg",
  },
  {
    id: 41,
    name: "Nginx",
    icon: "https://cdn.worldvectorlogo.com/logos/nginx-1.svg",
  },
  {
    id: 42,
    name: "Apache",
    icon: "https://cdn.worldvectorlogo.com/logos/apache-13.svg",
  },
  {
    id: 43,
    name: "Terraform",
    icon: "https://cdn.worldvectorlogo.com/logos/terraform-enterprise.svg",
  },
  {
    id: 44,
    name: "React Native",
    icon: "https://cdn.worldvectorlogo.com/logos/react-native-1.svg",
  },
  {
    id: 45,
    name: "Flutter",
    icon: "https://cdn.worldvectorlogo.com/logos/flutter-logo.svg",
  },
  {
    id: 46,
    name: "Kotlin",
    icon: "https://cdn.worldvectorlogo.com/logos/kotlin-1.svg",
  },
  {
    id: 47,
    name: "Swift",
    icon: "https://cdn.worldvectorlogo.com/logos/swift-15.svg",
  },
  {
    id: 48,
    name: "GraphQL",
    icon: "https://cdn.worldvectorlogo.com/logos/graphql-logo-2.svg",
  },
  {
    id: 49,
    name: "Go",
    icon: "https://cdn.worldvectorlogo.com/logos/go-8.svg",
  },
  {
    id: 50,
    name: "Jest",
    icon: "https://cdn.worldvectorlogo.com/logos/jest-2.svg",
  },
  {
    id: 51,
    name: "Kafka",
    icon: "https://cdn.worldvectorlogo.com/logos/kafka.svg",
  },
  {
    id: 52,
    name: "RabbitMQ",
    icon: "https://cdn.worldvectorlogo.com/logos/rabbitmq.svg",
  },
  {
    id: 53,
    name: "Postman",
    icon: "https://cdn.worldvectorlogo.com/logos/postman.svg",
  },
  {
    id: 54,
    name: "Figma",
    icon: "https://cdn.worldvectorlogo.com/logos/figma-icon.svg",
  },
  {
    id: 55,
    name: "Databricks",
    icon: "https://www.27global.com/wp-content/uploads/2025/04/Databricks-Logo.png",
  },
];
